import { connect } from "react-redux";

import QuestionReady from "components/answer/QuestionReady";

import { startEffect, finishEffect } from "redux/modules/answer/answerHeader";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("invalidOperation")));
  },
  handleNextBtn: () => {
    dispatch(startEffect());

    setTimeout(() => {
      history.push("/answer_question", ownProps);

      dispatch(finishEffect());
    }, 300);
  },
  handlePrevBtn: () => {
    dispatch(startEffect());

    setTimeout(() => {
      ownProps.history.goBack();

      dispatch(finishEffect());
    }, 300);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionReady);



// WEBPACK FOOTER //
// ./src/containers/preview/QuestionReadyContainer.js